import { render, staticRenderFns } from "./pipl-k11.vue?vue&type=template&id=0f96df67&scoped=true"
import script from "./pipl-k11.vue?vue&type=script&lang=js"
export * from "./pipl-k11.vue?vue&type=script&lang=js"
import style0 from "./pipl-k11.vue?vue&type=style&index=0&id=0f96df67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f96df67",
  null
  
)

export default component.exports